import React, { useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
// import { CircleLoading, GradientCircle, GradientCutCircle, InfoIcon, VerticalIcon } from "../../Assets/Icons";
import Dropdown from "react-bootstrap/Dropdown";
import { CircleLoading, GradientCircle, GradientCutCircle, InfoIcon, VerticalIcon } from "../assets/Icons";

const GroupUserCard = ({
  Name = "",
  Tag = "",
  Image = null,
  subGroup = "",
  groupUsers = "",
  assignedApps = "",
  assignedAppResource = {},
  onEditClick = () => {},
  onClick = () => {},
  fetchAssignedResourceData = () => {},
  cardTypeUser = false,
  userDes = "",
  userMail = "",
  dropdownItems,
  checkbox,
  isActive = true,
  group_id,
  user_id,
  mailIcon,
  editButtonEnable = true,
}) => {
  const handleEditClick = (e) => {
    e.stopPropagation();
    if (onEditClick) {
      onEditClick();
    }
  };
  const [imageError, setImageError] = useState(false);

  const handleOnClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const placeholderUserName = Name?.split(" ")
    .slice(0, 2)
    .map((e) => e.charAt(0).toUpperCase())
    .join("");

  const handleFetchTooltipData = () => {
    if (fetchAssignedResourceData) {
      fetchAssignedResourceData();
    }
  };

  const renderTooltipResources = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {assignedAppResource ? (
        Object.keys(assignedAppResource).length > 0 ? (
          <div className="resource-tooltip-parent">
            {Object.keys(assignedAppResource).map((item) => (
              <div className="resource-tooltip" key={item}>
                <p>{item}</p>
                <p className="number">{assignedAppResource[item]}</p>
              </div>
            ))}
          </div>
        ) : (
          <div className="resource-tooltip-parent">
            <div className="resource-tooltip">
              <p>No data found.</p>
              <p className="number"></p>
            </div>
          </div>
        )
      ) : (
        <div className="loading-button" style={{ width: "1.5rem", height: "1.5rem" }}>
          <CircleLoading />
        </div>
      )}
    </Tooltip>
  );

  return (
    <>
      <div style={{ position: "relative"}}>
        {checkbox && <div className="cardcheckbox">{checkbox}</div>}
        {dropdownItems && (
          <Dropdown className="carddropdown">
            <Dropdown.Toggle>
              <VerticalIcon />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {dropdownItems.map((item, index) => (
                <Dropdown.Item
                  key={index}
                  href={item.href || undefined}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (item.onClick) {
                      item.onClick();
                    }
                  }}
                >
                  <div className="dropdown-list-item">
                    {item.label}
                    {item.component}
                  </div>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}
        <div className={`group-user-card ${isActive ? "" : "disabled"} `} onClick={handleOnClick}>
          <div className="profile">
            {!editButtonEnable ? <GradientCircle /> : <GradientCutCircle />}
            {Image && !imageError ? (
              <img
                src={Image}
                referrerPolicy="no-referrer"
                className={cardTypeUser ? "user-image" : "group-image"}
                onError={() => setImageError(true)}
                alt="User or Group"
              />
            ) : (
              <span className="initials">{placeholderUserName}</span>
            )}
            {editButtonEnable && (
              <span className="edit-btn" onClick={handleEditClick}>
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.6941 9.94995C14.6941 12.09 14.6941 13.16 14.2775 13.9778C13.9128 14.6973 13.3275 15.2811 12.607 15.644C11.789 16.0643 10.7187 16.0644 8.57805 16.0644H7.04904C4.90842 16.0644 3.83811 16.0643 3.02008 15.644C2.29962 15.2811 1.71424 14.6973 1.34964 13.9778C0.932982 13.16 0.932983 12.09 0.932983 9.94995V8.42134C0.932983 6.28129 0.932982 5.21125 1.34964 4.39344C1.71611 3.67345 2.30075 3.08767 3.02008 2.71966C3.83811 2.30693 4.90842 2.3069 7.04904 2.3069M5.56742 9.56779C5.57354 9.30029 5.57737 9.1704 5.60947 9.04047C5.63853 8.92582 5.68363 8.82644 5.74479 8.72708C5.81283 8.61243 5.90763 8.5207 6.09646 8.32963L13.2798 1.10699C13.4602 0.925815 13.6973 0.811797 13.9516 0.783988C14.2058 0.756179 14.4619 0.816198 14.6773 0.954072C15.2029 1.29611 15.6515 1.74379 15.9945 2.26865C16.0136 2.29158 16.0335 2.32224 16.0519 2.35281C16.3393 2.81903 16.2453 3.3999 15.8684 3.78205L8.74166 10.9436C8.54518 11.1423 8.44731 11.2416 8.3334 11.3104C8.23117 11.3716 8.12075 11.4179 8.00544 11.448C7.87547 11.4785 7.7371 11.4786 7.45958 11.4786H5.52002L5.56742 9.56779Z"
                    stroke="#2F3A79"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            )}
          </div>
          <p className="name" title={Name}>
            {Name}
          </p>
          {userDes && <span className="identifier">{userDes}</span>}
          {group_id && <p className="identifier">{group_id}</p>}
          {Tag && <p className="Tag">{Tag}</p>}

          {cardTypeUser ? (
            <>
              <div className="stats user">
                {user_id && <p className="userid">{user_id}</p>}
                {userMail && (
                  <span className="mail-parent">
                    {mailIcon && (
                      <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M18.3325 4.85349L13.6507 7.70131C12.3273 8.50569 11.666 8.90869 10.9554 9.0655C10.3264 9.20362 9.67361 9.20362 9.04461 9.0655C8.33401 8.90869 7.6727 8.50569 6.34925 7.70131L1.66745 4.85349M18.3325 4.85349C18.5 5.63349 18.5 6.67675 18.5 8.29688C18.5 10.5719 18.5 11.7094 18.0368 12.5787C17.6296 13.3433 16.9794 13.9648 16.1795 14.3541C15.27 14.7969 14.08 14.7969 11.7 14.7969H8.3C5.92 14.7969 4.73 14.7969 3.8205 14.3541C3.02063 13.9648 2.37042 13.3433 1.96325 12.5787C1.5 11.7094 1.5 10.5719 1.5 8.29688C1.5 6.67675 1.5 5.63349 1.66745 4.85349M18.3325 4.85349C18.2746 4.56235 18.1751 4.2802 18.0368 4.015C17.6296 3.25042 16.9794 2.62889 16.1795 2.23969C15.27 1.79687 14.08 1.79688 11.7 1.79688H8.3C5.92 1.79688 4.73 1.79687 3.8205 2.23969C3.02063 2.62889 2.37042 3.25042 1.96325 4.015C1.82488 4.2802 1.72535 4.56235 1.66745 4.85349"
                          stroke="#2F3A79"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}
                    <p className="mail" title={userMail}>
                      {" "}
                      {userMail}
                    </p>
                  </span>
                )}
              </div>
            </>
          ) : (
            <div className="stats">
              {subGroup && (
                <span className="item">
                  <p>{subGroup}</p>
                  <span>Groups</span>
                </span>
              )}
              {groupUsers && (
                <span className="item">
                  <p>{groupUsers}</p>
                  <span>Users</span>
                </span>
              )}
              {assignedApps && (
                <span className="item">
                  <p>{assignedApps}</p>
                  <span>
                    Apps
                    <OverlayTrigger
                      onToggle={(isOpen) => {
                        if (isOpen) handleFetchTooltipData();
                      }}
                      placement="top"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltipResources}
                    >
                      <span onClick={(e) => e.stopPropagation()}>
                        <InfoIcon />
                      </span>
                    </OverlayTrigger>
                  </span>
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default GroupUserCard;
